import { forwardRef, ReactNode } from 'react';
import { Image } from '@ds';
import { ServiceCardUrl } from '@icons';
import { ClinicalMediaFile } from '@/api/apis/case';
import { getFileUrl } from '@/api/utils';
import { buildResizedImageUrl } from '@/utils/helpers/url.helpers';
import { IMAGE_SIZES } from '@/constants/image.constants';

type ClinicalGalleryItemProps = {
  topLabel?: string;
  bottomLabel?: string | ReactNode;
  file?: ClinicalMediaFile;
  topLabelClassName?: string;
  bottomLabelClassName?: string;
  containerClassName?: string;
  onClick?: () => void;
};

export const ClinicalGalleryItem = forwardRef<HTMLDivElement, ClinicalGalleryItemProps>(
  ({ topLabel, bottomLabel, file, topLabelClassName, bottomLabelClassName, containerClassName, onClick }, ref) => {
    const rawPath = file?.preview?.path || file?.path;
    const resizedPath =
      file?.mediaType === 'Photo' ? buildResizedImageUrl(rawPath ?? '', IMAGE_SIZES.THUMBNAIL) : (rawPath ?? '');

    const imageSrc = getFileUrl(resizedPath) || ServiceCardUrl;

    return (
      <div
        ref={ref}
        className={`relative cursor-pointer rounded-2xl min-w-24 max-w-[140px] min-h-[140px] bg-base-60 text-xs-m border-2 ${containerClassName}`}
      >
        {topLabel && (
          <div
            className={`absolute z-10 left-1 top-1 rounded-lg bg-maroon-20 px-1 py-0.5 text-white ${topLabelClassName}`}
          >
            {topLabel}
          </div>
        )}
        <Image
          alt="Preview image"
          onClick={onClick}
          className="z-0 object-cover"
          width="100%"
          height={140}
          src={imageSrc}
        />
        {bottomLabel && (
          <div className={`absolute z-10 left-1 bottom-1 rounded-lg bg-white px-1 py-0.5 ${bottomLabelClassName}`}>
            {bottomLabel}
          </div>
        )}
      </div>
    );
  },
);
